<template>
    <div class="mb-3">
        <div class="form-group" :class="{ 'money-field' : numberType === 'money'}">
            <label v-if="label && type !== 'checkbox'" class="form-label" :for="id">{{ label }}:</label>
            <div v-if="numberType === 'money'" class="money-label">$</div>
            <input :id="id" ref="input" v-bind="$attrs" class="form-control" :class="{error: error }" :type="type"
                   :value="numericValue" @input="$emit('input', $event.target.value)"/>
            <label v-if="label && type === 'checkbox'" class="form-check-label" :for="id">{{ label }}:</label>
        </div>
        <div v-if="error" class="help-block with-errors">{{ error }}</div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${this._uid}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        numberType: {
            type: String,
            default: 'number',
        },
        value: String,
        label: String,
        error: String,
    },
    data() {
        return {
            numericValue: this.value,
        }
    },
    watch: {
        value(value) {
            this.validate(value)
        },
    },
    mounted() {
        this.$el.addEventListener('paste', this.validatePaste);
    },
    destroyed() {
        this.$el.removeEventListener('paste', this.validatePaste);
    },
    methods: {
        focus() {
            this.validate(this.value)
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
        validate(value) {
            if (this.numberType === 'number') {
                this.numericValue = value.toString().replace(/\D/g, '')
            }

            if (this.numberType === 'phone') {
                let x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.numericValue = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            }

            if (this.numberType === 'money') {
                this.numericValue = value.toString()
                    .replace(/\D/g, '');
                this.numericValue = Intl.NumberFormat('en-US').format(this.numericValue)
            }
        },
        validatePaste(event){
            event.preventDefault()
            this.numericValue = ''
        },
    },
}
</script>
